import React, {memo, useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {H6Text} from '@buncha/components/core/text';
import {RescheduleOptionNode} from '@buncha/B2B/types/reschedule';
import {StyleSheet} from 'react-native';
import {TouchableOpacity} from 'react-native';

interface Props {
  node: RescheduleOptionNode;
  handleOnPress: (val: number) => void;
  disabled?: boolean;
}

const RescheduleRunSelectNode = (props: Props) => {
  const muli = useFontTheme('muli');
  const theme = useColorThemeType();
  const {node, handleOnPress, disabled} = props;

  const handlePress = useCallback(() => {
    handleOnPress(node?.id);
  }, [handleOnPress, node?.id]);

  return (
    <TouchableOpacity
      onPress={handlePress}
      style={styles.nodeTouchable}
      disabled={disabled}>
      <H6Text
        style={[
          styles.nodeText,
          {
            fontFamily: muli[700].normal,
            color: theme?.text.blue[300],
          },
        ]}>
        {node?.title}
        <H6Text
          style={[
            styles.nodeTextSubtitle,
            {
              fontFamily: muli[400].normal,
              color: theme?.text.blue[300],
            },
          ]}>
          {node?.subtitle}
        </H6Text>
      </H6Text>
    </TouchableOpacity>
  );
};

export default memo(RescheduleRunSelectNode);

const styles = StyleSheet.create({
  nodeTouchable: {flex: 1, padding: 12},
  nodeText: {textAlign: 'left'},
  nodeTextSubtitle: {textAlign: 'left', marginLeft: 12},
});
